import { useEffect } from "react";
import { getDataFileDownload, postDataFileDownload } from "./ApiService";
import { useToast } from "rc-toastr";

export const formatDateToDDMMMYYYY = (dateString: Date| string ) =>{
    if(dateString !== 'null'){
        const date = new Date(dateString);
        const monthNames = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];

        const day = date.getDate() < 10 ? '0'+ date.getDate(): date.getDate();
        const month = monthNames[date.getMonth()];
        const year = date.getFullYear();

        return `${day} ${month} ${year}`;
    }else{
        return null;
    }
    
}


export const formatDateToYYYYMMDD = (dateString: Date| string ) =>{
    const date = new Date(dateString);
    const day = date.getDate() < 10 ? '0'+ date.getDate(): date.getDate();
    const month = date.getMonth()+1;
    const year = date.getFullYear();

    return `${year}-${month}-${day}`;
}

export const usePageTitle = (title: string) => {
    useEffect(() => {
      document.title = title;
    }, [title]); // Update title whenever 'title' changes
};


export const getDateXDaysAgo = (x: number) =>{
    // Get the current date
    const currentDate = new Date();
  
    // Calculate the date x days ago
    const pastDate = new Date();
    pastDate.setDate(currentDate.getDate() - x);
  
    return pastDate;
}


export const setTokenExpiry = () => {
    const minutesFromNow = new Date().getTime() + (1000* 60 * 8);
    localStorage.setItem('tokenExpiryAt', minutesFromNow.toString());
}

export const downloadFile = (url: string, fileName: string ) =>{
    postDataFileDownload(url, {}).then((response)=>{
        const blobFile = new Blob([response?.data]);
        const downloadUrl = window.URL.createObjectURL(blobFile);
        const a = document.createElement("a");
        a.style.display = "none";
        document.body.appendChild(a);
        a.href = downloadUrl;
        a.download = fileName; 
        a.click();
        window.URL.revokeObjectURL(downloadUrl);
        a.remove();
    }).catch((error)=>{
        const { toast } = useToast();
        toast.error(error?.response?.data?.message);
    });
}


export const downloadFusionFile = (url: string, fileName: string ) =>{
    getDataFileDownload(url).then((response)=>{
        const blobFile = new Blob([response?.data]);
        const downloadUrl = window.URL.createObjectURL(blobFile);
        const a = document.createElement("a");
        a.style.display = "none";
        document.body.appendChild(a);
        a.href = downloadUrl;
        a.download = fileName; 
        a.click();
        window.URL.revokeObjectURL(downloadUrl);
        a.remove();
    }).catch((error)=>{
        const { toast } = useToast();
        toast.error(error?.response?.data?.message);
    });
}